/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GlobalConstants } from '../constants/global-constants';
import { LocalStorageService } from '../../../../utils/src/lib/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AcrylicSurfaceService {

  private readonly localStorageKey = GlobalConstants.ACRYLIC_OVERLAY;
  private isVisibleSubject = new BehaviorSubject<boolean>(false);
  public isVisible$ = this.isVisibleSubject.asObservable();

  constructor(private localStorageService: LocalStorageService) {
    window.addEventListener(GlobalConstants.STORAGE, this.syncState.bind(this));
  }

  public show(): void {
    this.localStorageService.updateDispatchLocalStorage(this.localStorageKey, 'true');
    this.isVisibleSubject.next(true);
  }

  public hide(): void {
    this.localStorageService.updateDispatchLocalStorage(this.localStorageKey, 'false');
    this.isVisibleSubject.next(false);
  }

  public syncState(event: StorageEvent) {
    if (event.key === this.localStorageKey) {
      this.isVisibleSubject.next(event.newValue === 'true');
    }
  }
}
